import axios from 'axios';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { can } from 'src/services/ability';
import ConditionalTooltip from 'src/components/ConditionalTooltip';
import DefaultBannerPath from 'src/images/default-banner.png';
import 'src/css/organizations/OrganizationsPublicProfileHeader.css';

function OrganizationsPublicProfileHeader({ organization }) {
  const authData = useSelector((state) => state.authData);
  const [searchParams, setSearchParams] = useSearchParams();
  const frame = searchParams.get('frame');
  const [eligibleToJoin, setEligibleToJoin] = useState(false);

  function getDynamicBannerStyle() {
    const backgroundImage = organization.banner ? organization.banner : DefaultBannerPath;
    return { backgroundImage: "url(" + backgroundImage + ")" };
  }

  useEffect(() => {
    if (!authData.loggedIn) {
      setEligibleToJoin(true);
    } else if (can(authData, 'read', 'Membership')) {
      fetchMembership();
    } else {
      setEligibleToJoin(false);
    }
  }, [authData])

  function fetchMembership() {
    axios.get('/api/v1/me/membership')
    .then((response) => {
      setEligibleToJoin(false);
    }, (error) => {
      setEligibleToJoin(true);
    });
  }

  function joinOrganizationClick() {
    window.open(organization.join_url, '_blank');
  }

  const showHeader = frame == null || (frame !== null && organization.display_info_when_framed === true);

  return (
    <Container className="organization-profile-header">
      {showHeader &&
        <Row className="justify-content-center">
          <Col xs={12} lg={10} xl={9} xxl={8} className="d-flex g-0 mt-md-2">
            <div style={getDynamicBannerStyle()} className="banner"></div>
          </Col>
          <Col xs={12} lg={10} xl={9} xxl={8}>
            <Row>
              <Col xs={6}>
                {organization.logo &&
                  <div className="ms-3 logo-container">
                    <img className="logo" src={organization.logo} alt="organization-logo" />
                  </div>
                }
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <div className="mt-2 mx-3">
                  <Row className="d-flex align-items-start mb-2 mb-md-0">
                    <Col md="auto">
                      <h5 className="d-inline-block">{organization.name}</h5>
                    </Col>
                    {organization.join_url && eligibleToJoin &&
                      <Col className="gx-md-0">
                        <ConditionalTooltip condition={organization.join_help_text !== ''} message={organization.join_help_text}>
                          <Button variant="outline-secondary" size="sm" className="join-org-btn" onClick={joinOrganizationClick}>
                            Post your job{' '}<i className="fa fa-chevron-right"></i>
                          </Button>
                        </ConditionalTooltip>
                      </Col>
                    }
                  </Row>
                  {organization.tagline && <div>{organization.tagline}</div>}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      }
    </Container>
  );
}

export default OrganizationsPublicProfileHeader;